import { Grid, Typography, withStyles } from '@material-ui/core';
import { Equalizer } from '@material-ui/icons';
import React from 'react';

const Level = ({value}) => (
  <Grid container alignItems={'center'}>
    <Grid item xs={1}>
      <Equalizer fontSize={'small'} color={'action'} />
    </Grid>
    <Grid item xs={10}>
      <Typography variant={'h6'}>{value + ' Level'} </Typography>
    </Grid>
  </Grid>
);

const styles = theme => ({});
export default withStyles(styles)(Level);
